import React from 'react'
import { useTransactionsController } from './TransactionsController'
import { TransactionsView } from './TransactionsView'

const TransactionsPage: React.FC = () => {
    const controller = useTransactionsController()
    return <TransactionsView {...controller} />
}

export default TransactionsPage
